import { BASE_URL } from 'constants/api';

import actions from 'actions/index';
import { stringify } from 'query-string';

export const ACTIONS = {
  GET: 'WORKSHEETS_GET',
  GET_SUCCESS: 'WORKSHEETS_GET_SUCCESS',
  GET_FAILURE: 'WORKSHEETS_GET_FAILURE',
};

export const get = actions.get(
  (worksheetId, query) => `${BASE_URL}/worksheets/${worksheetId}/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
